import React from 'react';
import Typography from "@mui/material/Typography";
import {Tooltip} from "antd";

function DownloadReport({handleDownload}) {
  return (
    <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: 10, alignItems: 'center'}}>
      <Typography fontSize={'small'} style={{marginRight: 10}}>Download as</Typography>
      <Tooltip title="Excel" onClick={handleDownload}>
        <img
          src={require('../../../assets/Images/downloadExcel.png')}
          width={'2.5%'}
          className="excel-image"
          alt="Excel"
          style={{cursor: 'pointer'}}
        />
      </Tooltip>
    </div>
  );
}

export default DownloadReport;
